/**
 * HOOK: useGameState
 * Gestisce lo stato principale del gioco
 */

import { useState, useCallback } from 'react'
import { GameState } from '../types/GameTypes'
import { GAME_CONFIG } from '../types/GameConstants'

export function useGameState() {
  const [gameState, setGameState] = useState<GameState>('menu')
  const [score, setScore] = useState<number>(0)
  const [lives, setLives] = useState<number>(GAME_CONFIG.INITIAL_LIVES)
  const [level, setLevel] = useState<number>(GAME_CONFIG.INITIAL_LEVEL)

  const startGame = useCallback(() => {
    setGameState('playing')
    setScore(0)
    setLives(GAME_CONFIG.INITIAL_LIVES)
    setLevel(GAME_CONFIG.INITIAL_LEVEL)
  }, [])

  const pauseGame = useCallback(() => {
    setGameState(prev => prev === 'playing' ? 'paused' : 'playing')
  }, [])

  const gameOver = useCallback(() => {
    setGameState('gameOver')
  }, [])

  const winGame = useCallback(() => {
    setGameState('win')
  }, [])

  const addScore = useCallback((points: number) => {
    setScore(prev => prev + points)
  }, [])

  const loseLife = useCallback(() => {
    setLives((prev: number) => {
      const newLives = prev - 1
      if (newLives <= 0) {
        setGameState('gameOver')
      }
      return newLives
    })
  }, [])

  const nextLevel = useCallback(() => {
    setLevel((prev: number) => prev + 1)
  }, [])

  return {
    // State
    gameState,
    score,
    lives,
    level,
    
    // Actions
    startGame,
    pauseGame,
    gameOver,
    winGame,
    addScore,
    loseLife,
    nextLevel,
    
    // Direct setters (for compatibility)
    setGameState,
    setScore,
    setLives
  }
}
